// Which web-access fields the Add External User form sends to the server.
//
// The form can match a person who already exists (same email or mobile). The
// server keeps whichever half is not sent, so:
//   - a matched person who already has a password keeps it unless the admin
//     clicks "Change password" — the password is then left out of the request;
//   - anyone else (a new person, or a matched person with no password yet) is
//     being given one, so what was typed must be sent.
export interface ExternalUserCredentialForm {
  /** Email as typed. */
  email: string;
  /** Password as typed. */
  password: string;
  /** The form matched an existing person who already has a web password. */
  existingHasPassword: boolean;
  /** The admin clicked "Change password" on that matched person. */
  changePassword: boolean;
}

export interface ExternalUserCredentialsToSend {
  email: string | undefined;
  password: string | undefined;
}

export const externalUserCredentialsToSend = (form: ExternalUserCredentialForm): ExternalUserCredentialsToSend => {
  const email = form.email.trim();
  const keepStoredPassword = form.existingHasPassword && !form.changePassword;
  return {
    email: email.length > 0 ? email : undefined,
    password: form.password.length > 0 && !keepStoredPassword ? form.password : undefined,
  };
};
